import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const fullNameLastNameViewer = {
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map